import { render, staticRenderFns } from "./MenuIMC.vue?vue&type=template&id=7ae71ab9&"
import script from "./MenuIMC.vue?vue&type=script&lang=js&"
export * from "./MenuIMC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports